import React from 'react';

export default function DatabaseDesign() {
  const serverURL = "https://ebay-app.cammezcollectables.com.au"; // ✅ must match your working domain

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Database Design Overview</h1>

      <div className="mb-4">
        <img
          src={`${serverURL}/api/db-design/ebay_cammez_ERD.png`}
          alt="Database ERD"
          className="rounded shadow"
          style={{ maxWidth: '100%' }}
        />
      </div>

      <a
        href={`${serverURL}/api/db-design/ebay_cammez_database_design.docx`}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 font-medium hover:underline"
      >
        📄 Download Full Design Document (Word)
      </a>
    </div>
  );
}
